import { Factory } from "./../core/factory";

import { BaseArcMark } from "./arc";

import { registerArc3dGraphic } from "@visactor/vgrammar-core";

import { registerVGrammarArcAnimation } from "../animation/config";

export class Arc3dMark extends BaseArcMark {
    constructor() {
        super(...arguments), this.type = Arc3dMark.type, this._support3d = !0;
    }
}

Arc3dMark.type = "arc3d";

export const registerArc3dMark = () => {
    registerVGrammarArcAnimation(), registerArc3dGraphic(), Factory.registerMark(Arc3dMark.type, Arc3dMark);
};
//# sourceMappingURL=arc-3d.js.map
